module.exports = __webpack_public_path__ + "img/email-demo.ebe0c9c7.png";